import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Tag } from "antd";
import {
  BarChartOutlined,
  DollarOutlined,
  ClusterOutlined,
  TeamOutlined,
  FileSearchOutlined,
  ThunderboltOutlined,
  ShareAltOutlined,
  LinkOutlined,
  VideoCameraOutlined,
  LockOutlined,
  OpenAIOutlined,
  BorderOuterOutlined,
} from "@ant-design/icons";
import "./marketplace.scss";
import {
  service,
  serviceTraffic,
  serviceAdvert,
  serviceAudience,
  serviceSearch,
  serviceCDN,
  serviceCAMPAIGN,
  serviceBytelive,
  serviceDrm,
  serviceAiTools,
  serviceReframe,
  servicePulse,
  accountId,
  getMarketplaceAccountConfig,
} from "../../config";

import { authTokenGet, dashboardLink } from "../../modules/user";

class Marketplace extends Component {
  constructor(props) {
    super(props);
    const marketplaceAccountConfig = getMarketplaceAccountConfig(accountId);

    this.state = {
      functions: [
        {
          id: "business-intelligence",
          title: "Business Intelligence",
          description:
            "Transform data into actionable insights for strategic decision-making",
          icon: <BarChartOutlined />,
          path: "/overview",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("business-intelligence:")
            ) && service.includes("business-intelligence"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("business-intelligence:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("business-intelligence")
            && marketplaceAccountConfig["business-intelligence"]?.hidden,
        },
        {
          id: "advertisement",
          title: "Advertisement",
          description: "Optimize ad performance and maximize revenue streams",
          icon: <DollarOutlined />,
          path: "/advertisement",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("advertisement:")
            ) && service.includes("advertisement"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("advertisement:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("advertisement") &&
            marketplaceAccountConfig["advertisement"]?.hidden,
        },
        {
          id: "traffic-management",
          title: "Traffic Management",
          description:
            "Monitor and analyze user traffic patterns across your platform",
          icon: <ClusterOutlined />,
          path: "/gtm/traffic",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("traffic-management:")
            ) && service.includes("traffic-management"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("traffic-management:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("traffic-management") &&
            marketplaceAccountConfig["traffic-management"]?.hidden,
        },
        {
          id: "audience",
          title: "Audience",
          description:
            "Understand viewer demographics and content consumption behaviors",
          icon: <TeamOutlined />,
          path: "/audience",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("audience:")
            ) && service.includes("audience"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("audience:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("audience") &&
            marketplaceAccountConfig["audience"]?.hidden,
        },
        {
          id: "cdn",
          title: "CDN",
          description: "The global content delivery platform that truly hops",
          icon: <LinkOutlined />,
          path: "/cdn",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("cdn:")
            ) && service.includes("cdn"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("cdn:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("cdn") && marketplaceAccountConfig["cdn"]?.hidden,
        },
        {
          id: "search-recommendation",
          title: "Search & Recommendation",
          description:
            "Track search patterns and enhance user experience with data-driven content suggestions",
          icon: <FileSearchOutlined />,
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("search-recommendation:")
            ) && service.includes("search-recommendation"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("search-recommendation:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("search-recommendation") &&
            marketplaceAccountConfig["search-recommendation"]?.hidden,
        },
        {
          id: "campaign",
          title: "Campaign Management",
          description:
            "Manage campaign dynamic shortened links and configurations",
          icon: <ShareAltOutlined />,
          path: "/campaign",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("campaign:")
            ) && service.includes("campaign"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("campaign:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("campaign") &&
            marketplaceAccountConfig["campaign"]?.hidden,
        },
        {
          id: "bytelive",
          title: "Bytelive",
          description:
            "Deliver seamless live streaming experiences with customizable broadcasting solutions for your platform",
          icon: <VideoCameraOutlined />,
          path: "/bytelive",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("bytelive:")
            ) && service.includes("bytelive"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("bytelive:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("bytelive") &&
            marketplaceAccountConfig["bytelive"]?.hidden,
        },
        {
          id: "drm",
          title: "DRM",
          description:
            "Secure your premium content with advanced digital rights management and anti-piracy protection",
          icon: <LockOutlined />,
          path: "/drm",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("drm:")
            ) && service.includes("drm"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("drm:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("drm") && marketplaceAccountConfig["drm"]?.hidden,
        },
        {
          id: "ai-tools",
          title: "AI Tools",
          description:
            "Leverage cutting-edge AI technologies to enhance content creation, personalization, and user engagement on your platform",
          icon: <OpenAIOutlined />,
          path: "/ai-tools",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("ai-tools:")
            ) && service.includes("ai-tools"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("ai-tools:"))
              ?.map((item) => item.split(":")[1]) || true,
          hidden:
            !service.includes("ai-tools") &&
            marketplaceAccountConfig["ai-tools"]?.hidden,
        },
        {
          id: "reframe",
          title: "Reframe",
          description:
            "AI-enhanced professional micro-drama generation tool that helps transform raw footage into polished stories with minimal effort",
          icon: <BorderOuterOutlined />,
          path: "/reframe",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("reframe:")
            ) && service.includes("bytelive"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("reframe:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("bytelive") &&
            marketplaceAccountConfig["reframe"]?.hidden,
        },
        {
          id: "pulse",
          title: "Pulse",
          description:
            "Transform passive viewers into active participants. Boost retention with real-time polls and granular audience sentiment analytics.",
          icon: <ThunderboltOutlined />,
          path: "/pulse",
          isShow:
            props.userProfile.user.access.some((item) =>
              item.startsWith("pulse:")
            ) && service.includes("pulse"),
          access:
            props.userProfile.user.access
              .filter((item) => item.startsWith("pulse:"))
              ?.map((item) => item.split(":")[1]) || false,
          hidden:
            !service.includes("pulse") &&
            marketplaceAccountConfig["pulse"]?.hidden,
        },
      ],
      activeFunction: null,
    };
  }

  componentDidMount() {
    this.checkUrlParams();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.checkUrlParams();
    }
  }

  checkUrlParams = () => {
    const { userProfile, location } = this.props;
    const urlParams = new URLSearchParams(location.search);
    const serviceParam = urlParams.get("service");

    // check if user is admin & logged in
    const isAdmin = userProfile.user && userProfile.user.role.includes("admin");
    const isAuthenticated = this.props.userAuthenticated;

    if (isAdmin && isAuthenticated && serviceParam) {
      // find the function based on service parameter
      const targetFunction = this.state.functions.find(
        (func) =>
          func.id === serviceParam ||
          func.title.toLowerCase().replace(/\s+/g, "-") === serviceParam
      );

      if (targetFunction) {
        // auto execute handleFunctionClick
        setTimeout(() => {
          this.handleFunctionClick(targetFunction, true);
        }, 100);
      }
    }
  };

  handleFunctionClick = async (selected, skipShowCheck) => {
    if (!skipShowCheck && !selected.isShow) return;
    if (selected.id === "traffic-management") {
      this.setState({ loading: true });
      let token = await authTokenGet();
      window.open(`${serviceTraffic}?auth_token=${token.auth_token}`, "_blank");
      this.setState({ loading: false });
    } else if (selected.id === "business-intelligence") {
      // redirect to grafana
      let dashboard = await dashboardLink();
      window.open(dashboard.link, "_blank");
    } else if (selected.id === "advertisement") {
      this.setState({ loading: true });
      let token = await authTokenGet();
      window.open(`${serviceAdvert}?auth_token=${token.auth_token}`, "_blank");
      this.setState({ loading: false });
    } else if (selected.id === "audience") {
      let token = await authTokenGet();
      window.open(
        `${serviceAudience}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "search-recommendation") {
      let token = await authTokenGet();
      window.open(`${serviceSearch}?auth_token=${token.auth_token}`, "_blank");
      this.setState({ loading: false });
    } else if (selected.id === "cdn") {
      let token = await authTokenGet();
      window.open(`${serviceCDN}?auth_token=${token.auth_token}`, "_blank");
      this.setState({ loading: false });
    } else if (selected.id === "campaign") {
      let token = await authTokenGet();
      window.open(
        `${serviceCAMPAIGN}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "bytelive") {
      let token = await authTokenGet();
      window.open(
        `${serviceBytelive}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "drm") {
      let token = await authTokenGet();
      window.open(
        `${serviceDrm}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "ai-tools") {
      let token = await authTokenGet();
      window.open(
        `${serviceAiTools}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "reframe") {
      let token = await authTokenGet();
      window.open(
        `${serviceReframe}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else if (selected.id === "pulse") {
      let token = await authTokenGet();
      window.open(
        `${servicePulse}?auth_token=${token.auth_token}`,
        "_blank"
      );
      this.setState({ loading: false });
    } else {
      this.setState({ activeFunction: selected.id });
      this.props.history.push(`${selected.path}`);
    }
  };

  render() {
    const { functions, activeFunction } = this.state;

    const sortedFunctions = [...functions]
      .filter((f) => !f.hidden)
      .sort((a, b) => {
        if (a.isShow && !b.isShow) return -1;
        if (!a.isShow && b.isShow) return 1;
        return 0;
      });

    return (
      <div className="functions-page">
        <div className="functions-container">
          <h1 className="functions-title">Business Solutions</h1>
          <div className="functions-grid">
            {sortedFunctions.map((func) => (
              <div
                key={func.id}
                className={`function-card ${activeFunction === func.id ? "active" : ""
                  } ${!func.isShow ? "dim" : ""}`}
                onClick={() => this.handleFunctionClick(func)}
              >
                {func.isShow && func.access && (
                  <Tag
                    className="function-access"
                    color="processing"
                    bordered={false}
                  >
                    {func.access}
                  </Tag>
                )}
                <div className="function-icon">{func.icon}</div>
                <div className="function-content">
                  <h3 className="function-title">{func.title}</h3>
                  <p className="function-description">{func.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  router: state.router,
  userAuthenticated: state.user.userAuthenticated,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Marketplace)
);
